

import { AngularFirestore } from 'angularfire2/firestore';
import { Pipe, PipeTransform } from '@angular/core';


import { ClientesConAcceso } from '../../services/clientes-con-acceso';

@Pipe({
    name: 'PasajerosParada' // nombre del pipe en las directivas
})

export class PasajerosViajePipe implements PipeTransform {

    constructor(private afs: AngularFirestore, private clientesConAcceso : ClientesConAcceso){}

    // Métdodo a implementar siempre
    transform(idViaje:string, idParada:string):any{
       return this.clientesConAcceso.obtenerpasajerosPorViaje(idViaje).valueChanges().map(pasajero => {
            let arreglo = [];
            for (const key in pasajero) {
              if (pasajero.hasOwnProperty(key)) {
                const element = pasajero[key];
                element.id = key;
                if (element.idParada == idParada) {
                  arreglo.push(element);
                }
              }
            }
            return arreglo;
          });
    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/obtener-pasajeros-viaje.pipe.ts